'use server'

import { apiRequest, ApiResponse } from '../request'

export interface Shortcut {
    id: number
    userId: number
    title: string
    path: string
    createdAt: string
    updatedAt: string
}

export interface CreateShortcutData {
    title: string
    path: string
}

export async function getShortcuts(): Promise<ApiResponse<Shortcut[]>> {
    return apiRequest('utils/shortcuts', {})
}

export async function createShortcut(
    data: CreateShortcutData
): Promise<ApiResponse<Shortcut>> {
    return apiRequest('utils/shortcuts', { data }, 'post')
}

export async function deleteShortcut(
    id: number
): Promise<ApiResponse<Shortcut>> {
    return apiRequest(`utils/shortcuts/${id}`, {}, 'delete')
}
